<div id="brand-settings" class="settings-page-container">
  <div class="settings-page-body">
    <!-- The preview comes first in the DOM so it stacks on top on mobile and at 400% zoom. -->
    <div
      class="tw-flex tw-flex-col tw-gap-6 tw-w-full tw-max-w-[1040px] tw-mx-auto md:tw-flex-row-reverse md:tw-items-start"
    >
      <aside
        class="tw-flex-none md:tw-basis-[360px] md:tw-sticky md:tw-top-0"
        aria-labelledby="brand-settings-preview-title"
      >
        <h2
          id="brand-settings-preview-title"
          class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2 tw-break-words"
        >
          {{ companyName }}
        </h2>
        <div
          id="brand-settings-preview"
          class="tw-flex tw-items-center tw-justify-center tw-aspect-video tw-rounded-lg tw-bg-gray-100 tw-border tw-border-solid tw-border-gray-200 tw-text-gray-700"
        >
          Brand preview
        </div>
      </aside>

      <div class="tw-flex tw-flex-col tw-gap-6 tw-flex-1 tw-min-w-0">
        <section
          id="brand-settings-logo"
          class="settings-page-section"
          aria-labelledby="brand-settings-logo-title"
        >
          <h2
            id="brand-settings-logo-title"
            class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2"
          >
            Logo
          </h2>
          <p class="tw-text-gray-600 tw-m-0">
            Logos apply to presentations automatically, and changing it will
            update current presentations that include the logo component.
          </p>
        </section>

        <section
          id="brand-settings-colors"
          class="settings-page-section"
          aria-labelledby="brand-settings-colors-title"
        >
          <h2
            id="brand-settings-colors-title"
            class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2"
          >
            Colors
          </h2>
          <p class="tw-text-gray-600 tw-m-0">
            Brand colors apply to presentations automatically, and changing them
            will update presentations with branding colors enabled.
          </p>
        </section>
      </div>
    </div>
  </div>
</div>
